/* eslint-disable no-extend-native */
Array.prototype.clone = function clone(arr) {
  return JSON.parse(JSON.stringify(arr))
}
